import { createAction } from 'redux-actions';

const setMandantList = createAction('SET_MANDANT_LIST');

export { setMandantList };